import {IconButton} from '@wandb/components';
import React from 'react';

import {Tooltip} from '../../weave/components/Tooltip';

export const WBAgentEntryPointIconButtonView = ({
  'aria-label': ariaLabel,
  'data-dd-action-name': ddActionName,
  'data-test': dataTest,
  isDisabled,
  onPress,
  variant = 'secondary',
}: {
  'aria-label': string;
  'data-dd-action-name'?: string;
  'data-test'?: string;
  isDisabled?: boolean;
  onPress: () => void;
  variant?: 'ghost' | 'secondary';
}) => (
  <Tooltip
    content={ariaLabel}
    side="top"
    trigger={
      <IconButton
        aria-label={ariaLabel}
        data-dd-action-name={ddActionName}
        data-test={dataTest}
        icon="lightboard-solid"
        isDisabled={isDisabled}
        variant={variant}
        onPress={onPress}
      />
    }
  />
);
